<template>
    <div class="activity-center">
        <loginIn v-if="isShowLogin"
            :isLoginFlag="isLogin"
            :loginType="loginType"
            :activityUrl="activityUrl"
            :isNeedWxAuth="false"></loginIn>
        <van-list v-model="listStatus.loading"
            :finished="listStatus.finished"
            :finished-text="finishedText"
            :error.sync="listStatus.error"
            error-text="请求失败，点击重新加载"
            :immediate-check="false"
            @load="getNextPage">
            <div v-if="activityList.length > 0"
                class="activity-list">
                <activityItem v-for="(item,index) in activityList"
                    :key="`item_index_${index}`"
                    :item="item"
                    :loginType="loginType"
                    @jump="jumpToDetail">
                </activityItem>
            </div>
            <div v-else
                class="no-data">
                <img class="no-data-img"
                    src="../../../../static/image/activityCenter/noData.png" />
                <div class="tips">暂无活动</div>
            </div>
        </van-list>
    </div>
</template>

<script>
import activityItem from './components/activityItem.vue';
import { config } from '../../../api/config';
import { updateUserInfoCache, AllLoginTypeHandler } from '../../../utils/comUtils';
import { LoginType, shareSwitch } from '../../../commons/commonVariables';
import { Toast } from 'vant';
import { getWxSDKAuth, getEnvMark } from '../runtime/common-methods/utils';
import wx from 'weixin-js-sdk';
import loginIn from '../runtime/dynamicAttr/modal/login-in.vue';
import { List } from 'vant';
import { EnvMark } from '../runtime/lucky-draw/common/global-variable';

export default {
  components: {
    activityItem,
    loginIn,
    [List.name]: List,
  },
  data() {
    return {
      activityList: [],
      activityListId: '',
      nextActivityCode: '',
      isLogin: false,
      loginType: 'none',
      storeCode: '',
      activityUrl: '',
      isShowLogin: false,
      listStatus: {
        loading: false,
        finished: false,
        error: false,
      },
      page: {
        curPage: 1,
        pageSize: 5,
        totalPages: 0,
      },
      finishedText: '',
    };
  },
  created() {
    // 是否使用登录组件
    const curEnv = getEnvMark();
    if (curEnv === EnvMark.wechatH5 || curEnv === EnvMark.alipayH5) {
      this.isShowLogin = true;
    } else {
      this.isShowLogin = false;
    }
    // query传参处理
    const query = this.$route.query;
    console.log('query===>', query);
    if (query && query.activityListId) {
      this.activityListId = query.activityListId || '';
      this.nextActivityCode = query.nextActivityCode;
      this.storeCode = query.storeCode || '';
      this.activityUrl = window.location.origin + window.location.pathname + `?activityListId=${this.activityListId}`;
      this.getActivityList();
    } else {
      console.error('activityListId不能为空');
    }
  },
  methods: {
    // 查询活动列表
    getActivityList() {
      Toast.loading({
        message: '加载中',
        forbidClick: true,
        duration: 0, // 默认值为2秒，设置为0，表示不会消失，需手动清除
      });
      const params = {
        curPage: this.page.curPage,
        pageSize: this.page.pageSize,
        filter: {
          activityPageCode: this.activityListId,
          channelCode: this.storeCode,
        },
        language: 'Cn',
        timezone: 'Asia/Shanghai',
      };
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: `listPage/queryActivityListPageByH5`,
        params: params,
        success: (res) => {
          Toast.clear();
          console.log('res===>', res);
          const { result } = res;
          this.activityList = [];
          if (res.code === 200 && result) {
            // 1.获取到基础数据
            // 设置页面标题
            window.document.title = result.activityListPageName;
            // 全部登录类型处理
            this.loginType = AllLoginTypeHandler(result.applicationSide);
            // 分享配置
            const shareObj = {
              shareSwitch: result.shareSwitch,
              shareTitle: result.shareTitle,
              shareSubtitle: result.shareSubtitle,
              sharePictures: this.$utils.getImageUrl(result.sharePictures),
            };
            const list = result.relationTDetailVOPaging || [];
            list.forEach((item, index) => {
              const row = {
                bigImageUrl: this.$utils.getImageUrl(item.activityPictures),
                activityName: item.activityName,
                activityStartTime: item.activityStartTime,
                activityEndTime: item.activityEndTime,
                activityGuideType: item.activityGuideType, // 活动导购状态
                status: item.activityStatus,
                guideStatus: item.appointmentStatus,
                activityCode: item.activityCode,
                activityType: item.activityType,
              };
              this.activityList.push(row);
              if (index === 0) {
                this.page.totalPages = item.pagingMap.totalPages;
              }
            });
            // 2.校验是否登录
            this.isLogin = this.checkLogin();
            // 3.未登录，尝试进行登录
            if (!this.isLogin) {
              if (this.loginType === LoginType.Wechat) {
                this.wxLogin().then((res) => {
                  // 登录成功，再次查询一遍数据
                  if (res) {
                    console.log('微信用户，登录成功！！！');
                    this.getActivityList();
                  } else {
                    console.log('微信用户，登录失败~~~');
                    this.jumpToNextActivity();
                    this.getWxConfig(shareObj);
                  }
                });
              } else if (this.loginType === LoginType.Alipay) {
                this.alipayLogin().then((res) => {
                  // 登录成功，再次查询一遍数据
                  if (res) {
                    console.log('支付宝用户，登录成功！！！');
                    this.getActivityList();
                  } else {
                    console.log('支付宝用户，登录失败~~~');
                    this.jumpToNextActivity();
                    this.getWxConfig(shareObj);
                  }
                });
              }
            } else {
              // 已登录,尝试跳转到下级活动
              this.jumpToNextActivity();
              this.getWxConfig(shareObj);
            }
          } else {
            Toast(res.message || '获取活动列表失败');
          }
        },
        failure: () => {
          Toast.clear();
          Toast('出错了，请稍后再试');
        },
      });
    },
    // 分页加载
    getNextPage() {
      if (this.page.curPage < this.page.totalPages) {
        this.page.curPage++;
        const params = {
          curPage: this.page.curPage,
          pageSize: this.page.pageSize,
          filter: {
            activityPageCode: this.activityListId,
            channelCode: this.storeCode,
          },
          language: 'Cn',
          timezone: 'Asia/Shanghai',
        };
        this.listStatus.loading = true;
        this.$api.post({
          noLoading: true,
          sc: 'mobileMarketingH5',
          url: `listPage/queryActivityListPageByH5`,
          params: params,
          success: (res) => {
            this.listStatus.loading = false;
            const { result } = res;
            if (res.code === 200 && result) {
              const list = result.relationTDetailVOPaging || [];
              list.forEach((item, index) => {
                const row = {
                  bigImageUrl: this.$utils.getImageUrl(item.activityPictures),
                  activityName: item.activityName,
                  activityStartTime: item.activityStartTime,
                  activityEndTime: item.activityEndTime,
                  activityGuideType: item.activityGuideType, // 活动导购状态
                  status: item.activityStatus,
                  guideStatus: item.appointmentStatus,
                  activityCode: item.activityCode,
                  activityType: item.activityType,
                };
                this.activityList.push(row);
                if (index === 0) {
                  this.page.totalPages = item.pagingMap.totalPages;
                }
              });
            } else {
              this.listStatus.error = true;
              this.listStatus.finished = false;
              Toast(res.message || '获取活动列表失败');
            }
          },
          failure: () => {
            this.listStatus.error = true;
            this.listStatus.loading = false;
            this.listStatus.finished = false;
            Toast('出错了，请稍后再试');
          },
        });
      } else {
        this.listStatus.finished = true;
        this.finishedText = '没有更多了';
      }
    },
    /**
     * 校验是否已登录
     */
    checkLogin() {
      // 本地默认登录
      if (window.location.host.includes('localhost')) {
        sessionStorage.setItem('isLoginFlag', 'true');
        const userObj = {
          openId: config.userInfo.userInfo.openId,
          unionid: config.userInfo.userInfo.unionid,
          accessToken: config.userInfo.accessToken,
          userToken: config.userInfo.userToken,
          memberCenterId: config.userInfo.userInfo.memberCenterId,
          member: config.userInfo.userInfo.member,
        };
        updateUserInfoCache(userObj, LoginType.Wechat);
        return true;
      } else {
        // 线上通过校验userInfo相关字段，来判断是否登录成功
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
        const flag = userInfo.accessToken && userInfo.userToken ? true : false;
        sessionStorage.setItem('isLoginFlag', flag);
        return flag;
      }
    },
    /**
     * 微信登录，返回登录结果。
     * 登录成功：设置userInfo缓存，已及isLoginFlag字段为TRUE。
     * 登录失败：清空userInfo缓存，已及isLoginFlag字段为FALSE。
     */
    wxLogin() {
      const loginCode = (this.$route.query && this.$route.query.loginCode) || '';
      if (loginCode) {
        const sc = this.$memberMixSwitch ? 'mobileWxMix' : 'mobileWx';
        const url = this.$memberMixSwitch ? 'quicklogin' : `getsession?code=${loginCode}`;
        const headers = this.$memberMixSwitch
          ? {
              'content-type': 'application/json',
              accept: 'application/json;charset=UTF-8',
            }
          : { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
        const params = this.$memberMixSwitch ? { code: loginCode } : '';
        return new Promise((resolve) => {
          this.$api.post({
            noLoading: true,
            sc: sc,
            url: url,
            params: params,
            headers: headers,
            success: (r) => {
              const userObj = {
                openId: '',
                unionid: '',
                accessToken: '',
                userToken: '',
                memberCenterId: '',
                member: false,
              };
              const isSuccess = this.$memberMixSwitch ? r.code === '666666' : r.data;
              if (isSuccess) {
                userObj.unionid = r.data.unionid || '';
                userObj.openId = r.data.openid || '';
                userObj.accessToken = r.data.accessToken || '';
                userObj.userToken = r.data.usertoken || '';
                userObj.memberCenterId = r.data.memberId || '';
                userObj.member = userObj.memberCenterId ? true : false;
              }
              // 以返回的result内的参数，作为是否登入成功的标识
              const isLoginFlag = r.result === 1 && userObj.accessToken && userObj.userToken ? true : false;
              const isLoginFlagMix = r.code === '666666' && userObj.accessToken && userObj.userToken ? true : false;
              // 缓存到session
              const flag = this.$memberMixSwitch ? isLoginFlagMix : isLoginFlag;
              sessionStorage.setItem('isLoginFlag', flag);
              updateUserInfoCache(userObj, LoginType.Wechat);
              this.$memberMixSwitch ? resolve(isLoginFlagMix) : resolve(isLoginFlag);
            },
            failure: () => {
              sessionStorage.setItem('isLoginFlag', 'false');
              updateUserInfoCache(null, LoginType.Wechat);
              resolve(false);
            },
          });
        });
      } else {
        // 未传wxLoginCode，设置isLoginFlag为FALSE，表示未登录
        sessionStorage.setItem('isLoginFlag', 'false');
        updateUserInfoCache(null, LoginType.Wechat);
        return Promise.resolve(false);
      }
    },

    /**
     * 支付宝登录，返回登录结果。
     * 登录成功：设置userInfo缓存，已及isLoginFlag字段为TRUE。
     * 登录失败：清空userInfo缓存，已及isLoginFlag字段为FALSE。
     */
    alipayLogin() {
      const loginCode = (this.$route.query && this.$route.query.loginCode) || '';
      if (loginCode) {
        return new Promise((resolve) => {
          const axios = require('axios');
          const qs = require('qs');
          const url = this.$memberMixSwitch ? `${config.hdBaseUrl}/mobileZuul/alipay/quicklogin` : `${config.hdBaseUrl}/mobileZuul/zfb/staticlogin`;
          const data = this.$memberMixSwitch ? { code: loginCode } : qs.stringify({ code: loginCode });
          const headers = this.$memberMixSwitch
            ? {
                'content-type': 'application/json',
                accept: 'application/json;charset=UTF-8',
              }
            : { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
          const param = {
            method: 'post',
            url: url,
            headers: headers,
            data: data,
          };
          axios(param)
            .then((response) => {
              if (response.data) {
                const tempData = response.data.data;
                const userObj = {
                  unionid: '',
                  accessToken: '',
                  userToken: '',
                  memberCenterId: '',
                  member: false,
                };
                if (tempData) {
                  userObj.unionid = tempData.unionid;
                  userObj.accessToken = tempData.accessToken || '';
                  userObj.userToken = tempData.usertoken || '';
                  userObj.memberCenterId = tempData.memberId || '';
                  userObj.member = userObj.memberCenterId ? true : false;
                }
                // 以返回的result内的参数，作为是否登入成功的标识
                const isLoginFlag = response.data && response.data.result === 1 && userObj.accessToken && userObj.userToken ? true : false;
                const isLoginFlagMix = response.data && response.data.code === '666666' && userObj.accessToken && userObj.userToken ? true : false;
                // 缓存到session
                const flag = this.$memberMixSwitch ? isLoginFlagMix : isLoginFlag;
                sessionStorage.setItem('isLoginFlag', flag);
                updateUserInfoCache(userObj, LoginType.Alipay);
                this.$memberMixSwitch ? resolve(isLoginFlagMix) : resolve(isLoginFlag);
              } else {
                sessionStorage.setItem('isLoginFlag', 'false');
                resolve(false);
              }
            })
            .catch(function (error) {
              console.log(error);
              sessionStorage.setItem('isLoginFlag', 'false');
              updateUserInfoCache(null, LoginType.Alipay);
              resolve(false);
            });
        });
      } else {
        sessionStorage.setItem('isLoginFlag', 'false');
        updateUserInfoCache(null, LoginType.Alipay);
        return Promise.resolve(false);
      }
    },
    /**
     * 跳转活动详情
     */
    jumpToDetail(item) {
      const params = {
        activityCode: item.activityCode,
        activityListId: this.activityListId,
      };
      // 透传链接的参数，目前只透传地理位置信息
      const query = this.$route.query;
      const keys = ['longitude', 'latitude', 'cityName', 'locationType'];
      if (query) {
        keys.forEach((key) => {
          if (query[key]) {
            params[key] = query[key];
          }
        });
      }
      this.$router.push({
        path: '/hdmain',
        query: params,
      });
    },
    jumpToNextActivity() {
      // 无论登录与否，都执行下级活动跳转逻辑
      if (this.nextActivityCode && sessionStorage.getItem('isJumpedNext') !== 'true') {
        Toast.loading({
          message: '即将跳转到活动详情页...',
          forbidClick: true,
          duration: 2000, // 默认值为2秒，设置为0，表示不会消失，需手动清除
        });
        setTimeout(() => {
          this.jumpToDetail({ activityCode: this.nextActivityCode });
          sessionStorage.setItem('isJumpedNext', 'true');
        }, 2000);
      }
    },
    getWxConfig(shareObj) {
      const openTagList = ['wx-open-launch-weapp'];
      const jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem'];
      getWxSDKAuth(openTagList, jsApiList).then((res) => {
        // 获取授权成功
        if (res) {
          console.log('获取微信授权成功');
          wx.ready(function () {
            if (shareObj.shareSwitch === shareSwitch.close) {
              // 隐藏所有非基础按钮接口
              wx.hideAllNonBaseMenuItem();
            } else {
              const url = window.location.href;
              // 显示所有功能按钮接口
              wx.showAllNonBaseMenuItem();
              // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
              wx.updateAppMessageShareData({
                title: shareObj.shareTitle,
                desc: shareObj.shareSubtitle,
                link: url,
                imgUrl: encodeURI(shareObj.sharePictures),
              });
              // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
              wx.updateTimelineShareData({
                title: shareObj.shareTitle,
                link: url,
                imgUrl: encodeURI(shareObj.sharePictures),
              });
            }
          });
        } else {
          console.log('获取微信授权失败');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-center {
  background-color: #f2f3f6;
  width: 100%;
  min-height: 100vh;
  position: relative;
  .activity-list {
    padding: 10px 0;
  }
  .no-data {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .no-data-img {
      width: 60vw;
      height: 50.67vw;
    }
    .tips {
      opacity: 0.6;
      font-family: HONORSansBrand-Regular;
      font-size: 14px;
      color: #000000;
      text-align: center;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/activityCenter/index.vue